<div class="copilot-container xwai-root">
  <button class="mobile-sidebar-toggle" (click)="toggleSidebar()">
    <span nz-icon [nzType]="sidebarVisible ? 'menu-fold' : 'menu-unfold'" nzTheme="outline"></span>
  </button>

  <div class="sidebar-overlay" [class.visible]="sidebarVisible" (click)="toggleSidebar()"></div>

  <div class="sidebar-wrapper" [class.visible]="sidebarVisible" [class.collapsed]="sidebarCollapsed">
    <app-copilot-sidebar [collapsed]="sidebarCollapsed" (collapseToggle)="toggleSidebarCollapse()"></app-copilot-sidebar>
  </div>

  <div class="mobile-action-bar">
    <button nz-button class="mobile-action-button" (click)="toggleSidebar()">
      <span nz-icon nzType="comment" nzTheme="outline"></span>
      <span>Conversations</span>
    </button>
    <button nz-button class="mobile-action-button" (click)="toggleImageFlipper()">
      <span nz-icon nzType="picture" nzTheme="outline"></span>
      <span>Image Flipper</span>
    </button>
  </div>

  <div class="main-content">
    <router-outlet></router-outlet>
  </div>

  <app-copilot-image-flipper #imageFlipper></app-copilot-image-flipper>
</div>
